import { useState, useEffect } from 'react';
import { auth, db } from '../firebase/config';
import { signOut } from 'firebase/auth';
import { doc, getDoc, collection, getDocs } from 'firebase/firestore';
import { useNavigate, Link } from 'react-router-dom';
import GameCard from '../components/GameCard';
import Navbar from '../components/Navbar';
import { useUser } from '../context/UserContext';

interface UserStats {
  tokens: number;
  gamesPlayed: number;
  highScores: {
    [key: string]: number;
  };
  displayName?: string;
}

interface GameConfig {
  id: string;
  title: string;
  description: string;
  url: string;
  imageUrl: string;
  isActive: boolean;
  addedDate: Date;
  requiredTokens?: number;
  category?: string;
}

const Dashboard = () => {
  const { userName, stats } = useUser();
  const navigate = useNavigate();
  const [games, setGames] = useState<GameConfig[]>([]);

  useEffect(() => {
    const fetchGames = async () => {
      const gamesRef = collection(db, 'games');
      const snapshot = await getDocs(gamesRef);
      const gamesList = snapshot.docs.map(doc => {
        console.log('Game data:', doc.data()); // Debug log
        return {
          id: doc.id,
          ...doc.data(),
          addedDate: doc.data().addedDate.toDate()
        };
      }) as GameConfig[];
      console.log('Processed games:', gamesList); // Debug log
      setGames(gamesList);
    };

    fetchGames();
  }, []);

  console.log('Rendering games:', games);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 text-white">
      <Navbar 
        userName={userName} 
        displayName={stats?.displayName}
      />

      <main className="max-w-7xl mx-auto p-6">
        <h2 className="text-3xl font-bold mb-8 text-center">Available Games</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {games.map(game => (
            <GameCard
              key={game.id}
              title={game.title}
              description={game.description}
              imageUrl={game.imageUrl}
              playLink={game.url}
              highScore={stats?.highScores?.[game.title.toLowerCase()] || 0}
            />
          ))}
        </div>
      </main>
    </div>
  );
};

export default Dashboard; 